 <template>
    <div class="index_wrap">
        <div style="margin-bottom: 20px;">
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="index_item_top">
                        <div class="index_item_tit">
                            <p><img src="../../assets/myWillDo.png"><span>我的待办</span></p>
                            <div class="item_tit_right">
                                <el-button @click="agencyCompleteFn('0')" :class="agency.complete == '0'? 'isActive' : ''" >未办</el-button>
                                <el-button @click="agencyCompleteFn('1')" :class="agency.complete == '1'? 'isActive' : ''" >已办</el-button>
                                <el-button @click="notCompleteFn('2')" :class="agency.complete == '2'? 'isActive' : ''" >未完成</el-button>
                            </div>
                        </div>
                        <div class="index_item_content myAgency" v-if="agency.complete == '2'">
                            <el-table class="settingHeight" :data="noCompleteData" >
                                <el-table-column label="名称" prop="title" >
                                    <template slot-scope="scope">
                                        <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类别" prop="type"></el-table-column>
                                <el-table-column label="日期" prop="time"></el-table-column>
                            </el-table>
                            <el-pagination small
                                @size-change="noCompleteSize"
                                @current-change="noCompleteCurrent"
                                :current-page="noComplete.pageIndex"
                                :pager-count="5"
                                :page-sizes="[10, 20]"
                                :page-size="noComplete.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="noCompleteTotal">
                            </el-pagination>
                        </div>
                        <div class="index_item_content myAgency" v-else>
                            <el-table class="settingHeight" :data="agency.complete == '0' ? myAgencyData:alreadyData" >
                                <el-table-column label="名称" prop="title" >
                                    <template slot-scope="scope">
                                        <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类别" prop="type"></el-table-column>
                                <el-table-column label="日期" prop="time"></el-table-column>
                            </el-table>
                            <el-pagination small @size-change="agencySize"
                                           @current-change="agencyCurrent"
                                           :current-page="agency.pageIndex"
                                           :pager-count="5"
                                           :page-sizes="[10,20]"
                                           :page-size="agency.pageSize"
                                           layout="total, sizes, prev, pager, next, jumper"
                                           :total="agencyTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="index_item_top">
                        <div class="index_item_tit">
                            <p><img src="../../assets/myApply.png"><span>我的请求</span></p>
                            <div class="item_tit_right">
                                <el-button @click="requestCompleteFn('0')" :class="request.complete == '0'? 'isActive' : ''" >未办</el-button>
                                <el-button @click="requestCompleteFn('1')" :class="request.complete == '1'? 'isActive' : ''" >已办</el-button>
                            </div>
                        </div>
                        <div class="index_item_content my_event">
                            <el-table class="settingHeight" :data="myRequestData" >
                                <el-table-column label="名称" prop="title" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类别" prop="type"></el-table-column>
                                <el-table-column label="日期" prop="time"></el-table-column>
                            </el-table>
                            <el-pagination small @size-change="requestSize"
                                           @current-change="requestCurrent"
                                           :current-page="request.pageIndex"
                                           :page-sizes="[10,20]"
                                           :pager-count="5"
                                           :page-size="request.pageSize"
                                           layout="total, sizes, prev, pager, next, jumper"
                                           :total="requestTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>

            </el-row>
<!--            <div class="index_item">-->
<!--                <div class="index_item_tit">-->
<!--                    <p><img src="../../assets/myWillDo.png"><span>我的待办</span></p>-->
<!--                    <div class="item_tit_right">-->
<!--                        <el-button @click="agencyCompleteFn('0')" :class="agency.complete == '0'? 'isActive' : ''" >未办</el-button>-->
<!--                        <el-button @click="agencyCompleteFn('1')" :class="agency.complete == '1'? 'isActive' : ''" >已办</el-button>-->
<!--                        <el-button @click="notCompleteFn('2')" :class="agency.complete == '2'? 'isActive' : ''" >未完成</el-button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="index_item_content myAgency" v-if="agency.complete == '2'">-->
<!--                    <el-table class="settingHeight" :data="noCompleteData" >-->
<!--                        <el-table-column label="名称" prop="title" >-->
<!--                            <template slot-scope="scope">-->
<!--                                <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="类别" prop="type"></el-table-column>-->
<!--                        <el-table-column label="日期" prop="time"></el-table-column>-->
<!--                    </el-table>-->
<!--                    <el-pagination @size-change="noCompleteSize"-->
<!--                                   @current-change="noCompleteCurrent"-->
<!--                                   :current-page="noComplete.pageIndex"-->
<!--                                   :page-sizes="[10,20]"-->
<!--                                   :page-size="noComplete.pageSize"-->
<!--                                   layout="total, sizes, prev, pager, next, jumper"-->
<!--                                   :total="noCompleteTotal">-->
<!--                    </el-pagination>-->
<!--                </div>-->
<!--                <div class="index_item_content myAgency" v-else>-->
<!--                    <el-table class="settingHeight" :data="agency.complete == '0' ? myAgencyData:alreadyData" >-->
<!--                        <el-table-column label="名称" prop="title" >-->
<!--                            <template slot-scope="scope">-->
<!--                                <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="类别" prop="type"></el-table-column>-->
<!--                        <el-table-column label="日期" prop="time"></el-table-column>-->
<!--                    </el-table>-->
<!--                    <el-pagination @size-change="agencySize"-->
<!--                                   @current-change="agencyCurrent"-->
<!--                                   :current-page="agency.pageIndex"-->
<!--                                   :page-sizes="[10,20]"-->
<!--                                   :page-size="agency.pageSize"-->
<!--                                   layout="total, sizes, prev, pager, next, jumper"-->
<!--                                   :total="agencyTotal">-->
<!--                    </el-pagination>-->
<!--                </div>-->

<!--            </div>-->

<!--            <div class="index_item">-->
<!--                <div class="index_item_tit">-->
<!--                    <p><img src="../../assets/myApply.png"><span>我的请求</span></p>-->
<!--                    <div class="item_tit_right">-->
<!--                        <el-button @click="requestCompleteFn('0')" :class="request.complete == '0'? 'isActive' : ''" >未办</el-button>-->
<!--                        <el-button @click="requestCompleteFn('1')" :class="request.complete == '1'? 'isActive' : ''" >已办</el-button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="index_item_content my_event">-->
<!--                    <el-table class="settingHeight" :data="myRequestData" >-->
<!--                        <el-table-column label="名称" prop="title" show-overflow-tooltip>-->
<!--                            <template slot-scope="scope">-->
<!--                                <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="类别" prop="type"></el-table-column>-->
<!--                        <el-table-column label="日期" prop="time"></el-table-column>-->
<!--                    </el-table>-->
<!--                    <el-pagination @size-change="requestSize"-->
<!--                                   @current-change="requestCurrent"-->
<!--                                   :current-page="request.pageIndex"-->
<!--                                   :page-sizes="[10,20]"-->
<!--                                   :page-size="request.pageSize"-->
<!--                                   layout="total, sizes, prev, pager, next, jumper"-->
<!--                                   :total="requestTotal">-->
<!--                    </el-pagination>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="myKnowledgeMes">
            <div>
                <span>知识搜索</span>
                <router-link :to="{ path: '/searchKnowledge' }">
                    <el-button type="text" class="rightDistance">常用知识</el-button>
                </router-link>
                <router-link :to="{ path: '/knowledgeList' }">
                    <el-button type="text" class="rightDistance">我的知识</el-button>
                </router-link>
                <el-input v-model="queryMes" class="searchInput" placeholder="关键字查询"></el-input>
                <el-button type="primary" @click="search">查询</el-button>
            </div>
            <div>
                <div v-show="index<12" v-for="(item,index) in knowledgeList" :key="index">
                    <!-- <router-link :to="{ path: '/knowledgeDetail',query:{message:item} }"> -->
                    <router-link :to="{ path: '/knowledgeDetail',query:{KnowledgeId:item.KnowledgeId,Version:item.Version} }">
                        <div class="showBorder setPadding"><a href="javascript:void(0);">{{item.Title}}</a></div>
                    </router-link>
                    <div class="setPadding"><p v-html="item.Body">{{item.Body}}</p></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import services from "./index.service";
    export default {
        data() {
            return {
                myAgencyData:[],           // 我的待办
                alreadyData:[],             //已办数据
                myRequestData:[],            //  我的请求
                noCompleteData:[], //未完成数据
                noComplete:{
                    pageIndex:1,
                    pageSize:10,
                },
                noCompleteTotal:0,
                agency:{
                    pageIndex:1,
                    pageSize:10,
                    complete:'0'
                },
                agencyTotal:0,
                request:{
                    pageIndex:1,
                    pageSize:10,
                    complete:"0"
                },
                requestTotal:0,
                knowledgeList:[],//知识搜索信息
                queryMes:'',//输入的关键字
                timer2:null,
            }
        },
        created() {
            // this.getAgencyList();
            this.getRequestList();
            this.search();
//            this.agencyListNotice()

        },
        mounted(){
            this.agencyCurrent(1)
        },
        watch:{
            myAgencyAllData:{
                handler(newval,oldval){
                    // console.log('index------watch')
                    if(newval){
                        this.agencyTotal = newval.length
                        this.agencyCurrent(1)
                    }
                },
                immediate:true
            }
        },
        computed:{
            userId:function () {
                return this.$store.state.userInfo.user.userId;
            },
            username:function () {
                return this.$store.state.userInfo.user.username
            },
            myAgencyAllData:function () {
                return this.$store.state.myAgencyData
            },
        },
        methods: {

            getAgencyList(){
                // let vm=this
                this.getAgencyInterval()
                // this.$interval(()=>{
                //     vm.getAgencyInterval()
                // },50000)
                // this.$interval(()=>{
                //     services.updateUser(this.username,window.localStorage.getItem('internalUserid'))
                // },50000)
            },
            getAgencyInterval(){
                let params = {
                    ...this.agency,
                    user:this.username,
                };
                services.getHomeList(params).then(res => {
                    this.alreadyData = res.list;
                    this.agencyTotal = res.total;
                }).catch(err => {
                    if (!this.errSum) {
                        this.$message.error(err.message);
                        this.errSum=1
                    }
                })
            },
            getRequestList(){
                // let vm=this
                this.getRequestInterval()
                // this.$interval(()=>{
                //     vm.getRequestInterval()
                // },50000)

                // this.timer2 = setInterval(()=>{
                //     vm.getRequestInterval()
                // },10000)
            },
            getRequestInterval(){
                let params = {
                    ...this.request,
                    user:this.username,
                };
                services.getRequestList(params).then(res => {
                    this.myRequestData = res.list;
                    this.requestTotal = res.total;
                }).catch(err => {
                    if (!this.errSum) {
                        this.$message.error(err.message);
                        this.errSum=1
                    }

                })
            },
            getNotCompleteList(){
                let params = {
                    pageIndex:this.noComplete.pageIndex,
                    pageSize:this.noComplete.pageSize
                };
                services.getNotCompleteList(params).then(res => {
                    this.noCompleteData = res.list;
                    this.noCompleteTotal = res.total;
                }).catch(err => {
                    if (!this.errSum) {
                        this.$message.error(err.message);
                        this.errSum=1
                    }
                })
            },
            notCompleteFn(val){
                this.agency.complete = val;
                this.getNotCompleteList()
                // this.timer2 = window.setInterval(()=>{
                //     this.getNotCompleteList();
                // },50000)

            },
            agencyCompleteFn(val){
                this.agency.complete = val;
                if(val == '1'){
                    this.agency.pageIndex=1
                    this.getAgencyList();
                }else{
                    this.agencyTotal = this.myAgencyAllData.length
                    this.agencyCurrent(1)

                }

            },
            requestCompleteFn(val){
                this.request.complete = val;
                this.getRequestList();
            },
            noCompleteSize(val){
                let pages = Math.ceil(this.noCompleteTotal / val);
                this.noComplete.pageSize = val;
                if(this.noComplete.pageIndex > pages ){
                    this.noComplete.pageIndex  = 1;
                }
                this.getNotCompleteList()
                // if(this.agency.complete=='2'){
                //     this.getNotCompleteList()
                // }else{
                //     this.getAgencyList()
                // }

            },
            noCompleteCurrent(val){
                this.noComplete.pageIndex = val;
                this.getNotCompleteList()
                // if(this.agency.complete=='2'){
                //     this.getNotCompleteList()
                // }else{
                //     this.getAgencyList();
                // }


            },
            agencySize(val){
                let pages = Math.ceil(this.agencyTotal / val);
                this.agency.pageSize = val;
                if(this.agency.pageIndex > pages ){
                    this.agency.pageIndex  = 1;
                };
                if(this.agency.complete=='1'){
                    this.getAgencyList()
                }else{
                    this.agencyCurrent(1)
                }

            },
            agencyCurrent(val){
                this.agency.pageIndex = val;
                if(this.agency.complete=='1'){
                    this.getAgencyList();
                }else{
                    //0
                    let start = (this.agency.pageIndex - 1) * this.agency.pageSize;
                    let end = start + this.agency.pageSize;
                    this.myAgencyData = this.myAgencyAllData.slice(start, end);
                }


            },
            requestSize(val){
                let pages = Math.ceil(this.requestTotal / val);
                this.request.pageSize = val;
                if(this.request.pageIndex > pages ){
                    this.request.pageIndex  = 1;
                }
                this.getRequestList()
            },
            requestCurrent(val){
                this.request.pageIndex = val;
                this.getRequestList();
            },
            search(){//知识搜索
                services.knowledgeQuery({"Query":this.queryMes,"pageIndex":1,"pageSize":12}).then(res => {
                    this.knowledgeList = res.KnowledgeTable;
                }).catch(err => {
                    if (!this.errSum) {
                        this.$message.error(err.message);
                        this.errSum=1
                    }
                })
            },
            //点击待办或请求中列表名称时跳转对应详情
            toCorrectDetail(val){
                let sn=val
                let hrefurl
                if (sn.indexOf('Eve')>-1) {
                    // this.$router.push({path:'/eventDetail',query:{serialNumber:sn}})
                    hrefurl = this.$router.resolve({path:'/eventDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Cha')>-1){
                    hrefurl = this.$router.resolve({path:'/changeDetail',query:{serialNumber:sn}})
                    // this.$router.push({path:'/changeDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Dep')>-1){
                    hrefurl = this.$router.resolve({path:'/deployDetail',query:{serialNumber:sn}})
                    // this.$router.push({path:'/deployDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Pro')>-1){
                    hrefurl = this.$router.resolve({path:'/problemDetail',query:{serialNumber:sn}})
                    // this.$router.push({path:'/problemDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Res')>-1){
                    hrefurl = this.$router.resolve({path:'/resourceApplyDetail',query:{serialNumber:sn}})
                }
                window.open(hrefurl.href,'_blank')
            },
        },
    }
</script>

<style lang="scss"  rel="stylesheet/scss">
    @import "./index";
    body{
        .index_item_top{
            background-color: white;
            border-radius:5px;
        }
      .noticeInform{
            background: #a8e0ff;
          .el-notification__content{
              font-size: 16px;
          }
          .el-notification__closeBtn{
              color: white;
              font-size: 20px;
              &:hover{
                  color: black;
              }
          }
        }
    }

</style>
